var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemixers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12004 8.65255C9.04504 8.64505 8.95504 8.64505 8.87254 8.65255C8.01169 8.62333 7.19602 8.26018 6.59826 7.64002C6.0005 7.01986 5.66759 6.19139 5.67004 5.33005C5.67004 3.49255 7.15504 2.00005 9.00004 2.00005C9.43685 1.99217 9.87093 2.07041 10.2775 2.23029C10.6841 2.39017 11.0552 2.62856 11.3696 2.93186C11.6841 3.23516 11.9357 3.59743 12.1101 3.99797C12.2846 4.39851 12.3784 4.82949 12.3863 5.2663C12.3942 5.70311 12.3159 6.1372 12.1561 6.54377C11.9962 6.95035 11.7578 7.32145 11.4545 7.63589C11.1512 7.95033 10.7889 8.20196 10.3884 8.3764C9.98783 8.55084 9.55685 8.64467 9.12004 8.65255ZM5.37004 11.4201C3.55504 12.6351 3.55504 14.6151 5.37004 15.8226C7.43254 17.2026 10.815 17.2026 12.8775 15.8226C14.6925 14.6076 14.6925 12.6276 12.8775 11.4201C10.8225 10.0476 7.44004 10.0476 5.37004 11.4201Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemixers);
export default __webpack_public_path__ + "static/media/remixers.2696f8b97333b3c628db3d884984eaee.svg";
export { ForwardRef as ReactComponent };